"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Moon;

var _Moon = require("@adobe/react-spectrum-workflow/dist/Moon");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Moon(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Moon.A4uMoon, null));
}